/**
 * WorkspaceLayout V2
 *
 * Layout-Container für den Workspace mit Sidebar und Content-Bereich.
 * Flexbox Layout (Sidebar + Content), Full-height minus Navbar.
 *
 * @accessibility WCAG 2.1 AA + BFSG konform
 */

import { Outlet, useLocation } from 'react-router-dom';
import { ToolsSidebar } from '@/components/v2/tools/layout';

export function ToolsLayout() {
  const location = useLocation();
  const reloadKey = location.state?.reload || 0;

  return (
    <div className="flex h-[calc(100vh-56px)] pb-16 lg:pb-0">
      {/* Sidebar */}
      <ToolsSidebar />

      {/* Main Content */}
      <main className="flex-1 overflow-auto bg-white dark:bg-neutral-950">
        <Outlet key={reloadKey} />
      </main>
    </div>
  );
}

export default ToolsLayout;
